import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Contexts/AuthContext';
import { Templates_Get_All, Templates_Initialize, Templates_Update } from '../../api/API_Templates'
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Card from '../ERUMAUI/UI_Card';
import Icon_User from '../../Assets/Icons/Icon_User.png';
import Icon_Map from '../../Assets/Icons/Icon_Map.png';
import Icon_Edit from '../../Assets/Icons/Icon_Edit.png';
import Icon_Clock from '../../Assets/Icons/Icon_Clock.png';
import Icon_List from '../../Assets/Icons/Icon_List.png';
import Icon_Calendar from '../../Assets/Icons/Icon_Calendar.png';
import Icon_ReservationSlip from '../../Assets/Icons/Icon_ReservationSlip.png';
import Icon_Template from '../../Assets/Icons/Icon_Template.png';
import Icon_Report from '../../Assets/Icons/Icon_Reports.png';
import Icon_Settings from '../../Assets/Icons/Icon_Settings.png';
import Icon_Logout from '../../Assets/Icons/Icon_Logout.png';
import Icon_Calendar_NoUpcoming from '../../Assets/Icons/Icon_Color_Reserved.png';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useAccounts } from '../../Contexts/Context_Accounts';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import List_Activities from '../ScheduleManagement/List_Activities';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Section_Title from '../ERUMAUI/UI_Section_Title';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';


export default function Panel_Home_Center() {
    const { Account, Loading, Logout } = useAuth();
    const { Accounts_List_Pending } = useAccounts();
    const { Slide_Switch, Slide_Active } = useStatus();
    const { Schedules_ByUser, Time_Range_Parse, Status_Parse, Schedule_Display } = useScheduleManagement();
    const Navigate = useNavigate();

    const Access_InteractiveMap = Account?.Access.InteractiveMap.View;
    const Access_Schedules = Account?.Access.Schedules.View;
    const Access_Reports = Account?.Access.Report.View;
    const Access_Account = Account?.Access.Account.Manage_Others;
    const Access_Templates = Account?.Access.Templating.View;

    const Handle_Click = (ID) => {
        Schedule_Display(ID);
        Navigate("/schedules/manage")
    }

    const [Activities_Enabled, Activities_Enabled_Set] = useState(true);


    if (Loading) {
        return null;
    }
    return (

        <>
            <UI_Horizontal_Tabs
                Selectors={[
                    {
                        Icon: null,
                        Text: "Upcoming activities"
                    },
                    Account?.Access?.Schedules?.View &&
                    {
                        Icon: null,
                        Text: "Your reservation status"
                    }
                ]}
                UIDs={["UpcomingActivities", "Reservations"]}
                Selected={"Tab_UpcomingActivities"}
                Components={[
                    <>
                        <UI_Section_Title
                            Text="Upcoming activities"
                            Icon={<UI_Icon Name="Calendar" />}
                            Margins={true}
                        />
                        <List_Activities />
                    </>,
                    <>
                        <UI_Section_Title
                            Text="Your reservation status"
                            Icon={<UI_Icon Name="Calendar" />}
                            Margins={true}
                        />
                        <UI_UpdatingStatus
                            State={Account?.Access?.Schedules?.View && Schedules_ByUser.length > 0 ? "Good" : "Bad"}
                            Good={{
                                Type: "Custom",
                                Content: <>
                                    <div className='General_List' style={{ marginTop: "10px" }}>
                                        {Schedules_ByUser.map((Item) => (
                                            <UI_Card
                                                Type="Schedule_List"
                                                Figure={
                                                    {
                                                        Title: Item.Name,
                                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                        Chip: Status_Parse(Item, true, true)
                                                    }
                                                }
                                                onClick={() => Handle_Click(Item._id)}
                                            />
                                        ))}
                                    </div>
                                </>
                            }}
                            Bad={{
                                Type: "Default",
                                Icon: Icon_Calendar_NoUpcoming,
                                Text: "No reservations for now."
                            }}
                        />
                    </>
                ]}
            />

        </>
    );
}
